<template>
  <div class="prompt-block">
    <div class="prompt-bubble" data-testid="ai-chat-prompt-bubble">
      {{ block.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PromptBlock } from '../../types'

/* the merchant's own message */
defineProps<{
  block: PromptBlock
}>()
</script>

<style scoped>
.prompt-block {
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  align-items: flex-end;
  max-width: 88%;
}

.prompt-bubble {
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  border-bottom-right-radius: 0.1875rem;
  background: var(--el-text-color-primary);
  color: var(--el-bg-color);
  font-size: 0.875rem;
  line-height: 1.5;
}
</style>
